export default __webpack_public_path__ + "ccb4237.png";